export default {
  "app": {
    "title": "Juego de la Vida"
  },
  "nav": {
    "home": "Inicio",
    "play": "Jugar",
    "explore": "Explorar",
    "about": "Acerca de",
    "user": "Usuario",
    "userMenu": "Menu de usuario",
    "profile": "Perfil",
    "settings": "Configuracion",
    "signOut": "Cerrar sesion",
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "toggleDarkMode": "Cambiar modo oscuro",
    "viewSource": "Ver código fuente en GitHub"
  },
  "footer": {
    "label": "Pie global",
    "blurb": "Laboratorio del Juego de la Vida de Conway",
    "sourceLink": "Codigo abierto en GitHub",
    "releaseLink": "Version actual",
    "shortcuts": {
      "menuLabel": "Atajos de teclado",
      "title": "Atajos de teclado",
      "currentContext": "Contexto actual: {{context}}",
      "focusHint": "Las teclas rapidas solo funcionan cuando el foco no esta dentro de un campo de entrada, selector, area de texto o boton.",
      "controlPrefix": "Control: {{control}}",
      "availableNow": "Disponibles ahora",
      "allShortcuts": "Todos los atajos de la pagina de juego",
      "noShortcutsHere": "No hay atajos especificos activos en esta vista.",
      "currentBadge": "Actual",
      "contextLanding": "Pagina de inicio",
      "contextPlaySelect": "Selector de patrones",
      "contextPlayEdit": "Pagina de juego - Modo edicion",
      "contextPlayRun": "Pagina de juego - Modo ejecucion",
      "contextExplore": "Pagina Explorar",
      "contextAbout": "Pagina Acerca de",
      "contextProfile": "Pagina Perfil",
      "contextSettings": "Pagina Configuracion",
      "actions": {
        "panBoard": "Mover el tablero",
        "zoomBoard": "Acercar o alejar el tablero",
        "centerView": "Centrar la vista del tablero",
        "toggleSimulation": "Iniciar o pausar simulacion",
        "increaseSpeed": "Aumentar velocidad de generacion",
        "decreaseSpeed": "Reducir velocidad de generacion"
      },
      "controls": {
        "panControls": "Controles de desplazamiento",
        "zoomControls": "Controles de acercar y alejar",
        "centerView": "Control de centrar vista",
        "startPause": "Control de iniciar / pausar",
        "increaseSpeed": "Control de aumentar velocidad de generacion",
        "decreaseSpeed": "Control de reducir velocidad de generacion"
      }
    }
  },
  "landing": {
    "eyebrow": "Laboratorio de Automatas Celulares",
    "title": "Bienvenido a Juego de la Vida",
    "description": "Explora comportamientos emergentes a partir de reglas simples. Inicia el tablero interactivo, carga patrones iniciales y observa como emerge la complejidad.",
    "enter": "Entrar a la Simulacion",
    "nextPattern": "Mostrar el siguiente patron",
    "patternCount": "{{current}} / {{total}}",
    "about": "Leer Acerca de",
    "presetsTitle": "Probar Un Patron",
    "presetsDescription": "Entra directamente al tablero con un patron precargado.",
    "openPreset": "Abrir Patron",
    "presets": {
      "default": {
        "title": "R-Pentomino",
        "description": "La semilla clasica usada en esta app: pequena, pero con una evolucion sorprendentemente rica."
      },
      "gosper": {
        "title": "Canon Planeador de Gosper",
        "description": "El primer patron finito famoso que emite una corriente infinita de planeadores."
      },
      "simkin": {
        "title": "Canon Planeador de Simkin",
        "description": "Un canon planeador compacto de periodo 120 y contraparte moderna del de Gosper."
      }
    },
    "feature1": "Cuadricula infinita interactiva",
    "feature2": "Patrones predefinidos y semillas personalizadas",
    "feature3": "Reglas configurables, diagnosticos y URLs compartibles"
  },
  "controls": {
    "title": "Controles del Juego",
    "start": "Iniciar",
    "pause": "Pausar",
    "next": "Siguiente",
    "reset": "Reiniciar",
    "copyUrl": "Copiar URL",
    "mode": "Modo",
    "playControls": "Controles de Juego",
    "editControls": "Controles de Edicion",
    "variables": "Variables del Juego",
    "generationSpeed": "Velocidad de Generación",
    "generationSpeedDecrease": "Reducir velocidad de generacion",
    "generationSpeedIncrease": "Aumentar velocidad de generacion",
    "generationSpeedValue": "Velocidad de generacion {{level}}",
    "edit": "Editar",
    "editMode": "Modo de Edición",
    "modeToggleHotkey": "M",
    "selection": "Seleccionar celdas",
    "grabPan": "Mover con mano",
    "stamp": "Estampar patron",
    "stampPatterns": "Patrones iniciales",
    "currentStampSelection": "Seleccion actual",
    "searchStampPatterns": "Buscar patrones",
    "filterStampCategory": "Filtrar por categoria",
    "allStampCategories": "Todas las categorias",
    "noStampPatternsFound": "No hay patrones que coincidan con tu busqueda.",
    "rotateStamp": "Rotar sello",
    "rotateStampHotkey": "[ / ] / R",
    "stampRotation": "{{degrees}} grados",
    "selectionCount": "{{count}} seleccionadas",
    "liveCellsSelected": "{{count}} celulas vivas seleccionadas",
    "undo": "Deshacer",
    "pencil": "Lapiz",
    "eraser": "Borrador",
    "drawColor": "Color de dibujo",
    "systemColors": "Colores del sistema",
    "customColors": "Colores personalizados",
    "customColor": "Color personalizado",
    "customColorHex": "Hex de color personalizado",
    "hoveredCell": "Cursor",
    "hoveredCellNone": "Ninguna",
    "miniMap": "Minimapa",
    "miniMapViewport": "Vista actual",
    "maximizeBoard": "Maximizar tablero",
    "restoreBoard": "Restaurar diseño",
    "panUp": "Mover arriba",
    "panLeft": "Mover a la izquierda",
    "centerView": "Centrar vista",
    "panRight": "Mover a la derecha",
    "panDown": "Mover abajo",
    "zoomOut": "Alejar",
    "zoomIn": "Acercar",
    "editModeOn": "Modo de edición ACTIVADO - Haz clic en las celdas para cambiar",
    "editModeOff": "Modo de edición DESACTIVADO"
  },
  "patterns": {
    "title": "Patrones Iniciales",
    "custom": "Patrón Personalizado",
    "loadCustom": "Cargar Patrón Personalizado",
    "placeholder": "Pegar coordenadas aquí...",
    "showExamples": "Mostrar ejemplos",
    "hideExamples": "Ocultar ejemplos",
    "supportedFormats": "Formatos soportados:"
  },
  "colors": {
    "title": "Paleta de Colores"
  },
  "rules": {
    "title": "Reglas del Juego",
    "description": "Activa o desactiva reglas para personalizar el comportamiento de la simulación",
    "standardSection": "Reglas Estándar",
    "experimentalSection": "Reglas Experimentales",
    "highlifeTag": "HighLife",
    "highlifeReproductionDescription": "Las celulas muertas con exactamente tres o seis vecinas vivas se convierten en celulas vivas (reproduccion HighLife B36).",
    "lockButton": "Bloquear reglas",
    "unlockButton": "Desbloquear reglas",
    "lockedHint": "Las reglas estan bloqueadas para este juego. Desbloquea para editar.",
    "unlockedHint": "Las reglas estan desbloqueadas. Bloquealas para evitar cambios.",
    "unlockConfirmTitle": "Desbloquear reglas del juego?",
    "unlockConfirmMessage": "Al desbloquear, permites cambios de reglas para este juego. Continuar?",
    "unlockConfirmAction": "Desbloquear"
  },
  "playground": {
    "copyHash": "Copiar Hash",
    "save": "Guardar",
    "saveAs": "Guardar Como",
    "saveOptions": "Opciones de guardado",
    "fork": "Clonar",
    "forkSuffix": "Clon",
    "savePrompt": "Guardar plantilla como",
    "editTitle": "Editar titulo de plantilla",
    "forkTitle": "Ponle nombre a tu clon",
    "createFork": "Crear clon",
    "patternName": "Nombre del patron",
    "patternMetadata": "Metadatos del patron",
    "infoTab": "Info",
    "infoTitle": "Acerca de",
    "infoAuthorLabel": "Autor",
    "infoCategoryLabel": "Categoria",
    "infoForkedFromLabel": "Clonado de",
    "infoDescriptionLabel": "Descripcion",
    "editPatternInfo": "Editar informacion del patron",
    "infoVisibilityLabel": "Visibilidad",
    "infoPopularityLabel": "Popularidad",
    "infoStarsLabel": "{{count}} estrellas",
    "infoForksLabel": "{{count}} clones",
    "infoForksMetaLabel": "Clones",
    "viewForks": "Ver clones",
    "removeStarConfirmTitle": "Quitar estrella?",
    "removeStarConfirmMessage": "Quitar tu estrella de {{name}}?",
    "removeStarConfirmAction": "Quitar estrella",
    "infoDescriptionSystem": "Un patron {{category}} integrado en la biblioteca del sistema.",
    "infoDescriptionUser": "Un patron comunitario de {{category}} creado por {{creator}}.",
    "infoDescriptionForked": "Esta version fue clonada de {{name}}.",
    "starsModalTitle": "Con estrellas de ({{pattern}})",
    "forksModalTitle": "Clonado por ({{pattern}})",
    "forkingPatternLabel": "lo clono como {{pattern}}",
    "forkedDateLabel": "Clonado",
    "lastModifiedDateLabel": "Ultima modificacion",
    "noStarsYet": "Aun no hay estrellas locales.",
    "noForksYet": "Aun no hay clones locales.",
    "unknownForkPattern": "Patron clonado desconocido",
    "youUserLabel": "Tu",
    "popularityBadge": "{{stars}} estrellas · {{forks}} clones",
    "categoryBadge": "Categoria: {{category}}",
    "createdByLabel": "Autor:",
    "createdByBadge": "Autor: {{creator}}",
    "forkedFrom": "Clonado de: {{name}}",
    "originalPattern": "Patron original",
    "categoryUncategorized": "Sin categoria",
    "categoryUnknown": "Personalizado",
    "visibilityPublic": "Publico",
    "visibilityPrivate": "Privado",
    "insertSystemPattern": "Insertar Patron del Sistema",
    "systemReadonlyHint": "Los patrones del sistema son de solo lectura. Clonalos para crear una copia editable.",
    "unsavedEmptyBoardNotice": "Tablero sin guardar",
    "confirmDraftSaveTitle": "Guardar tablero",
    "confirmDraftEditTitle": "Editar tablero",
    "confirmDraftSaveMessage": "Guardar este tablero en tu cuenta como \"{{name}}\"?",
    "confirmDraftSaveAction": "Guardar tablero",
    "confirmDraftSaveNamePlaceholder": "Ingresa un nombre de tablero",
    "confirmDraftSaveCategoryLabel": "Categoria",
    "confirmDraftSaveCategoryPlaceholder": "Selecciona una categoria",
    "confirmDraftSaveDescriptionPlaceholder": "Agrega una descripcion opcional",
    "confirmDraftSaveTagsLabel": "Etiquetas",
    "confirmDraftSaveTagsPlaceholder": "Agrega etiquetas separadas por comas",
    "confirmDraftSaveVisibilityLabel": "Visibilidad",
    "confirmDraftSaveCategoryHint": "Elige categoria y visibilidad, y revisa nombre/descripcion antes del primer guardado."
  },
  "diagnostics": {
    "title": "Diagnósticos",
    "settings": "Configuracion",
    "activeRulesetLabel": "Conjunto activo",
    "rulesetLabel": "Conjunto de reglas",
    "rulesetDescription": "Elige la familia de simulacion. Conway usa B3/S23; HighLife agrega nacimientos B6 (B36/S23).",
    "rulesetStandardOption": "Conway (B3/S23)",
    "rulesetHighlifeOption": "HighLife (B36/S23)",
    "rulesetCustomOption": "Reglas personalizadas",
    "rulesetCustomClassification": "Personalizado",
    "stabilityOverlayEnabled": "Mostrar modal de estabilidad",
    "stabilityOverlayDescription": "Cuando esta desactivado, Continuar jugando oculta el modal de estabilidad hasta que lo vuelvas a activar.",
    "birthDeathPreviewEnabled": "Mostrar vista previa de vida/nacimiento",
    "birthDeathPreviewDescription": "Previsualiza la siguiente generación: las celdas verdes nacen y los contornos rojos marcan las celdas que morirán.",
    "statistics": "Estadísticas",
    "generations": "Generaciones",
    "liveCells": "Células Vivas",
    "liveCellsByColor": "Células vivas por color",
    "noLiveCellsByColor": "Aún no hay células vivas.",
    "liveCellsCount": "{{count}} vivas",
    "generationInteractions": "Interacciones de la última generación",
    "overcrowdingDeathsByOtherColor": "Registro acumulado de muertes por sobrepoblación por color de presión",
    "noOvercrowdingDeathsByOtherColor": "No hubo muertes por sobrepoblación entre colores en la última generación.",
    "overcrowdingDeathsCount": "{{count}} desplazadas",
    "experimentalBirthsByColor": "Nacimientos por reglas experimentales por color",
    "experimentalRulesDisabled": "Activa las reglas experimentales de especies para rastrear nacimientos por competencia.",
    "noExperimentalBirthsByColor": "No hubo nacimientos por competencia en la última generación.",
    "experimentalBirthsCount": "{{count}} nacidas",
    "tieBreakBirthsCount": "{{count}} por desempate",
    "totalBirths": "Nacimientos Totales",
    "totalDeaths": "Muertes Totales",
    "cellData": "Datos de Células"
  },
  "about": {
    "title": "Acerca del Juego de la Vida de Conway",
    "whatIsIt": "¿Qué es el Juego de la Vida de Conway?",
    "description1": "El Juego de la Vida de Conway es un autómata celular ideado por el matemático John Horton Conway en 1970. Es un juego de cero jugadores, lo que significa que su evolución está determinada por su estado inicial, sin requerir más entradas.",
    "description2": "El juego consiste en una cuadrícula de células que pueden estar vivas o muertas. Cada célula interactúa con sus ocho vecinos según cuatro reglas simples:",
    "rule1": "Cualquier célula viva con 2-3 vecinos vivos sobrevive",
    "rule2": "Cualquier célula muerta con exactamente 3 vecinos vivos se vuelve viva",
    "rule3": "Todas las demás células vivas mueren en la siguiente generación",
    "rule4": "Todas las demás células muertas permanecen muertas",
    "description3": "A pesar de estas reglas simples, el Juego de la Vida puede producir patrones y comportamientos increíblemente complejos, convirtiéndolo en un ejemplo fascinante de complejidad emergente.",
    "projectTitle": "Acerca de Este Proyecto",
    "projectDescription": "Esta es una implementación en TypeScript del Juego de la Vida de Conway que incluye:",
    "feature1": "Lógica central funcional pura con pruebas unitarias exhaustivas",
    "feature2": "Interfaz interactiva basada en React con componentes personalizados de Wintermuted",
    "feature3": "Estructura de datos basada en diccionario optimizada para cuadrículas dispersas",
    "feature4": "Patrones precargados que incluyen vidas inmóviles, osciladores, naves espaciales y matusalenes",
    "feature5": "Compartir patrones basado en URL",
    "linksTitle": "Enlaces",
    "viewSource": "Ver Código Fuente en GitHub",
    "wikiLink": "Juego de la Vida de Conway en Wikipedia"
  },
  "explore": {
    "title": "Explorar Patrones",
    "subtitle": "Explora patrones comunes del Juego de la Vida, ejecútalos al instante, clónalos a tus patrones guardados y marca favoritos para verlos en tu perfil.",
    "searchPlaceholder": "Buscar patrones o categorias",
    "categoryFilterLabel": "Categoria",
    "categoryAll": "Todas las categorias",
    "showMoreFilterOptions": "Mostrar {{count}} mas",
    "showFewerFilterOptions": "Mostrar menos",
    "noFiltersAvailable": "No hay filtros disponibles.",
    "sourceFilterLabel": "Origen",
    "authorFilterLabel": "Autor",
    "authorAll": "Todos los autores",
    "rulesetFilterLabel": "Conjunto de reglas",
    "rulesetAll": "Todos los conjuntos de reglas",
    "tagFilterLabel": "Etiquetas",
    "tagAll": "Todas las etiquetas",
    "rulesetCustom": "Personalizado",
    "sortLabel": "Ordenar patrones",
    "sortFavorites": "Mas favoritos",
    "sortForks": "Mas clonados",
    "sortName": "Nombre",
    "sortCategory": "Categoria",
    "sortUser": "Usuario",
    "sortDirectionLabel": "Direccion",
    "sortDirectionAsc": "Ascendente",
    "sortDirectionDesc": "Descendente",
    "groupByLabel": "Agrupar patrones",
    "groupNone": "Sin agrupar",
    "groupCategory": "Categoria",
    "groupRuleset": "Conjunto de reglas",
    "groupAuthor": "Autor",
    "viewModeLabel": "Modo de vista",
    "viewCards": "Tarjetas",
    "viewTable": "Tabla",
    "allPatternsGroupLabel": "Todos los patrones",
    "favoritesOnly": "Solo favoritos",
    "forkedOnly": "Solo clonados",
    "clearFilters": "Limpiar filtros",
    "resultsCount": "{{count}} patrones",
    "noResultsTitle": "No se encontraron patrones",
    "noResults": "Ningun patron coincide con los filtros actuales.",
    "tablePattern": "Patron",
    "tableSource": "Origen",
    "tableCategory": "Categoria",
    "tableRuleset": "Conjunto de reglas",
    "tableTags": "Etiquetas",
    "tableForks": "Clones",
    "tableStars": "Estrellas",
    "tableActions": "Acciones",
    "categoryLabel": "Categoria: {{category}}",
    "popularityLabel": "Popularidad del patron",
    "playPattern": "Jugar",
    "forkPattern": "Clonar",
    "viewFavorites": "Ver favoritos",
    "favorite": "Estrellas",
    "favorited": "Con estrellas",
    "forkSuffix": "Clon"
  },
  "profile": {
    "title": "Perfil",
    "subtitle": "Administra los detalles de tu cuenta y vuelve rapido a estados guardados del tablero.",
    "openPlayground": "Abrir Tablero",
    "user": {
      "name": "James Nyeholt",
      "email": "james@example.com",
      "memberSince": "Abril 2026",
      "timezone": "America/Los_Angeles",
      "favoritePalette": "Verde Clasico"
    },
    "details": {
      "memberSince": "Miembro desde",
      "timezone": "Zona horaria",
      "favoritePalette": "Paleta favorita",
      "boardsSaved": "Tableros guardados"
    },
    "savedBoards": {
      "title": "Tableros Guardados",
      "items": {
        "rpentomino": {
          "title": "Semilla R-Pentomino",
          "updated": "Actualizado hace 2 dias"
        },
        "gosper": {
          "title": "Laboratorio Canon Gosper",
          "updated": "Actualizado hace 5 dias"
        },
        "simkin": {
          "title": "Flujo Compacto Simkin",
          "updated": "Actualizado hace 1 semana"
        }
      }
    },
    "recentBoards": {
      "title": "Tableros Recientes",
      "items": {
        "glider": {
          "title": "Calentamiento Planeador",
          "updated": "Abierto hace 45 minutos"
        },
        "blinker": {
          "title": "Revision de Ritmo Blinker",
          "updated": "Abierto ayer"
        },
        "pulsar": {
          "title": "Sandbox Pulsar",
          "updated": "Abierto hace 3 dias"
        }
      }
    },
    "myBoards": {
      "title": "Mis Tableros",
      "empty": "Aun no hay tableros personales. Guarda un tablero no clonado para verlo aqui."
    },
    "createEmptyBoard": "Crear tablero vacio",
    "emptyBoardTitle": "Tablero vacio",
    "forkedBoards": {
      "title": "Tableros Clonados",
      "empty": "Aun no hay tableros clonados. Clona un tablero en Jugar para verlo aqui."
    },
    "stars": {
      "title": "Tableros con Estrellas",
      "empty": "Aun no hay estrellas. Marca tableros en Explorar para verlos aqui."
    },
    "tableBoard": "Tablero",
    "tableDetails": "Origen",
    "tableUpdated": "Actualizado",
    "tableLiveCells": "Celulas",
    "tableOriginFork": "Clon de {{name}}",
    "tableOriginMine": "Mio",
    "tableOriginLibrary": "Biblioteca",
    "forkedFrom": "Clonado de {{name}}",
    "removeStar": "Quitar estrella",
    "openBoard": "Abrir Tablero",
    "liveCells": "{{count}} celulas vivas",
    "storageModeLabel": "Modo de almacenamiento",
    "persistenceNote": "La persistencia de backend y los datos de cuenta se conectaran en una actualizacion futura."
  },
  "playStart": {
    "title": "Iniciar un Juego Nuevo",
    "subtitle": "Elige como quieres comenzar en Jugar.",
    "emptyTitle": "Crear Tablero Vacio",
    "emptyDescription": "Comienza con una cuadricula vacia y construye tu propio patron.",
    "emptyAction": "Comenzar Vacio",
    "randomTitle": "Patron Aleatorio del Sistema",
    "randomDescription": "Empieza con un patron integrado aleatorio de la biblioteca del sistema.",
    "randomAction": "Comenzar Aleatorio"
  },
  "settings": {
    "title": "Configuracion",
    "stubDescription": "Elige como guardar estado temporal mientras la persistencia de backend esta en progreso.",
    "persistenceNote": "Estas opciones son provisionales en el navegador hasta que existan ajustes de cuenta en backend.",
    "storage": {
      "title": "Almacenamiento del Navegador",
      "description": "Tableros guardados, tableros recientes y datos de perfil se guardan en el almacenamiento seleccionado.",
      "local": "Almacenamiento local",
      "localHint": "Persiste en este dispositivo aunque cierres el navegador.",
      "session": "Almacenamiento de sesion",
      "sessionHint": "Se limpia cuando termina la sesion de la pestaña/ventana.",
      "clearActive": "Limpiar datos del almacenamiento activo",
      "summaryTitle": "Resumen de Datos Guardados",
      "activeMode": "Modo activo",
      "savedTemplates": "Plantillas guardadas",
      "savedBoards": "Tableros guardados",
      "recentBoards": "Tableros recientes",
      "profileName": "Nombre de perfil",
      "profileEmail": "Correo del perfil",
      "savedListTitle": "Titulos de tableros guardados",
      "recentListTitle": "Titulos de tableros recientes",
      "emptyList": "Aun no hay entradas guardadas"
    },
    "messages": {
      "storageSaved": "Modo de almacenamiento actualizado",
      "activeDataCleared": "Datos del almacenamiento activo eliminados"
    }
  },
  "signOut": {
    "title": "Cerrar sesion",
    "stubDescription": "Este es un flujo provisional de cierre de sesion.",
    "persistenceNote": "La autenticacion y el manejo de sesion se implementaran mas adelante.",
    "returnToPlay": "Volver a Jugar"
  },
  "messages": {
    "urlUpdated": "URL actualizada con el patrón actual",
    "urlCopied": "URL copiada al portapapeles",
    "urlCopyFailed": "Error al copiar URL",
    "hashCopied": "Hash del patron copiado al portapapeles",
    "hashCopyFailed": "Error al copiar hash del patron",
    "simulationStarted": "Simulacion iniciada",
    "simulationPaused": "Simulacion en pausa",
    "playModeEntered": "Entraste en modo jugar",
    "editModeEntered": "Entraste en modo edicion",
    "enterPlayModeToRun": "Entra en modo jugar antes de ejecutar la simulacion",
    "enterEditModeToInsertPattern": "Entra en modo edicion antes de insertar un patron",
    "generationSpeedChanged": "Velocidad de generacion: {{level}}",
    "pauseToInsertPattern": "Pausa la simulacion antes de insertar un patron",
    "boardUndoApplied": "Se revirtio el cambio anterior del tablero",
    "systemPatternInserted": "Se inserto un patron del sistema",
    "stampPatternSelected": "Patron de estampado seleccionado",
    "stampPatternApplied": "Patron estampado en el tablero",
    "stampRotationUpdated": "Rotacion del sello: {{degrees}} grados",
    "selectStampPatternFirst": "Selecciona primero un patron inicial para estampar",
    "selectionColorFilled": "Celdas seleccionadas rellenadas con {{color}}",
    "areaColorFilled": "Area conectada rellenada con {{color}}",
    "templateSaved": "Plantilla guardada",
    "rulesetApplied": "Se aplico {{name}} ({{classification}})",
    "customColorUpdated": "Color personalizado actualizado: {{color}}",
    "patternForked": "Se clono {{name}} a tus patrones guardados",
    "patternFavorited": "Se agrego {{name}} a favoritos",
    "patternUnfavorited": "Se quito {{name}} de favoritos",
    "stabilityDetectedTitle": "Poblacion estable detectada",
    "stabilityDetectedDescription": "El conteo de celulas vivas no cambio durante 20 generaciones. Simulacion en pausa.",
    "gameOverTitle": "Fin del juego",
    "gameOverDescription": "Ya no quedan celulas vivas en el tablero.",
    "stabilityBannerTitle": "Estabilidad lograda",
    "stabilityBannerDescription": "El conteo de celulas vivas se mantuvo en {{liveCells}} durante {{generations}} generaciones.",
    "returnToEditMode": "Volver al modo edicion",
    "continuePlaying": "Continuar jugando"
  },
  "patternSource": {
    "system": "Sistema",
    "user": "Usuario",
    "byUser": "Por {{name}}"
  },
  "dialogs": {
    "confirmReset": "Confirmar Reinicio",
    "resetMessage": "¿Estás seguro de que quieres reiniciar el juego? Esto borrará el estado actual y comenzará de nuevo.",
    "close": "Cerrar",
    "cancel": "Cancelar",
    "yesReset": "Sí, Reiniciar"
  }
};
